import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FrontdeskService } from '../../../services/frontdesk/frontdesk.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoaderComponent } from '../../../atoms/loader/loader.component';

// perform a check-out for one booking. data = { requisitionId, familyCode, name }.
@Component({
  selector: 'app-checkout-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, LoaderComponent],
  templateUrl: './checkout-dialog.component.html',
  styleUrls: ['./checkout-dialog.component.scss', '../../../../common-style/ac-dialog.scss'],
})
export class CheckoutDialogComponent {
  form: FormGroup;
  isLoading: boolean = false;
  // the old desk's fixed vocabularies
  commentCategories = ['Good', 'Better', 'Best', 'Bad', 'Worst'];
  ratings = [1, 2, 3, 4, 5];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CheckoutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { requisitionId: number; familyCode: string; name: string },
    private frontdeskService: FrontdeskService,
    private toastService: ToastService
  ) {
    this.form = this.fb.group({
      outRegisterSigned: [false],
      keyRecieptUser: [''],
      outRegSignedUser: [''],
      commentsCategory: [''],
      devoteeRating: [null],
      additionalComments: [''],
      devoteeFeedback: [''],
      // the checker's confirmation gates the Check out button (never stored)
      checkerFinalAcceptance: [false],
    });
  }

  submit(): void {
    if (!this.form.value.checkerFinalAcceptance) {
      this.toastService.error('Confirm the checker acceptance first.');
      return;
    }
    this.isLoading = true;
    const v = this.form.value;
    const payload = {
      requisitionId: this.data.requisitionId,
      outRegisterSigned: !!v.outRegisterSigned,
      keyRecieptUser: v.keyRecieptUser || '',
      outRegSignedUser: v.outRegSignedUser || '',
      commentsCategory: v.commentsCategory || '',
      devoteeRating: v.devoteeRating != null && v.devoteeRating !== '' ? Number(v.devoteeRating) : undefined,
      additionalComments: v.additionalComments || '',
      devoteeFeedback: v.devoteeFeedback || '',
    };
    this.frontdeskService.checkout(payload).subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Checked out.');
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Check-out failed.');
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
